<div class="card-modal mx-3">
  <div class="row mx-3 my-0">
    <div class="col-2 fs-6 fw-bold">
      <span class="px-0 pe-0"> {{ "FactorId" | translate }}: </span>
    </div>
    <div class="col-2 fs-6">
      <p class="m-0 px-0">
        {{ data.factorId }}
      </p>
    </div>
    <div class="col-2 fs-6 fw-bold">
      <span class="px-0 pe-0"> {{ "factorDate" | translate }}: </span>
    </div>
    <div class="col-2 fs-6">
      <p class="m-0 px-0">
        {{ data.factorDate | dataType : "" }}
      </p>
    </div>
    <div class="col-2 fs-6 fw-bold">
      <span class="px-0 pe-0"> {{ "companyName" | translate }}: </span>
    </div>
    <div class="col-2 fs-6">
      <p class="m-0 px-0">
        {{ data.companyName }}
      </p>
    </div>
  </div>
  <div class="row mx-3 my-0">
    <div class="col-2 fs-6 fw-bold">
      <span class="px-0 pe-0"> {{ "TotalPrice" | translate }}: </span>
    </div>
    <div class="col-2 fs-6">
      <p class="m-0 px-0">
        {{ data.totalPrice | dataType : "price" }}
      </p>
    </div>
    <div class="col-2 fs-6 fw-bold">
      <span class="px-0 pe-0"> {{ "BuyDiscount" | translate }}: </span>
    </div>
    <div class="col-2 fs-6">
      <p class="m-0 px-0">
        {{ data.discount | dataType : "price" }}
      </p>
    </div>
    <div class="col-2 fs-6 fw-bold">
      <span class="px-0 pe-0"> {{ "state" | translate }}: </span>
    </div>
    <div class="col-2 fs-6">
      <p class="m-0 px-0">
        {{ data.state }}
      </p>
    </div>
  </div>
  <div class="row mx-3 my-0 border-ridge">
    <div class="col-2 fs-6 fw-bold">
      <span class="m-0 px-0"> {{ "Description" | translate }}: </span>
    </div>
    <div class="col-10 fs-6">
      <p class="m-0 px-0">
        {{ data.description }}
      </p>
    </div>
  </div>
</div>

<div class="row p-1 m-0 drug-list" style="width: 100%">
  <div class="mvc-grid-table">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col">{{ "Row" | translate }}</th>
          <th scope="col">{{ "drugBrandName" | translate }}</th>
          <th scope="col">{{ "Number" | translate }}</th>
          <th scope="col">{{ "Lack" | translate }}</th>
          <th scope="col">{{ "expireDate" | translate }}</th>
          <th scope="col">{{ "buyPrice" | translate }}</th>
          <th scope="col">{{ "TotalAmount" | translate }}</th>
          <th scope="col">{{ "" | translate }}</th>
        </tr>
      </thead>
      <tbody id="rows">
        <tr *ngFor="let item of data.returnDrug; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ item.drugName }}</td>
          <td>{{ item.count | dataType : "" }}</td>
          <td>
            {{ item.shortageCount | dataType : "" }}
          </td>
          <td>{{ item.expireDate | dataType : "" : false }}</td>
          <td>
            {{ item.buyPrice | dataType : "price" }}
          </td>
          <td>
            {{ item.totalPrice | dataType : "price" }}
          </td>
          <td>
            <button
              type="button"
              class="btn btn-icon btn-outline-primary"
              [ngbTooltip]="'Edit' | translate"
              (click)="startEdit(item, i)"
            >
              <i class="fa fa-edit"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row p-1 m-0 drug-list" style="width: 100%" *ngIf="EditItem">
      <div class="mvc-grid-table">
        <div id="add-box" class="row add-box-item">
          <div class="col-12 col-lg-9 col-md-9">
            <div class="row input-box drug-information-box my-3 mx-2 p-2">
              <div class="col-12">
                <div class="input-box-title-box px-2">
                  <span>{{ "DrugInformation" | translate : "" }}</span>
                </div>
                <div class="edit-form">
                  <div class="validation-alert-sale-buy">
                    <p>{{ editableItemMessage.drugName }}</p>
                  </div>
                  <label class="form-label" for="drugBrandName">
                    {{ "ProductBrandName" | translate }}
                  </label>

                  <input
                    disabled
                    id="drugBrandName"
                    type="text"
                    autocomplete="off"
                    class="form-control Focusable iner-Focusable search-input-box"
                    placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                    [ngClass]="{
                      'is-invalid':
                        editableItemMessage.drugName != '' &&
                        editableItemMessage.drugName != null
                    }"
                    [(ngModel)]="editableItem.drugName"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="edit-form row drugcount-status">
                  <div
                    class="col-xxl-3 p-xxl-0 ps-xxl-3 col-md-5 ps-md-3 col-sm-3 ps-sm-3 p-xs-0 col-5 p-2"
                  >
                    <label class="form-label" for="Number">
                      {{ "packageCount" | translate }}
                    </label>
                    <input
                      #count
                      id="packageCount"
                      type="text"
                      autocomplete="off"
                      appSelectOnFocus
                      class="form-control input-one Focusable iner-Focusable"
                      [(ngModel)]="editableItem.packageCount"
                      [ngClass]="{
                        'is-invalid':
                          editableItemMessage.count != '' &&
                          editableItemMessage.count != null
                      }"
                      (keyup)="packageKeyUp()"
                      (ngModelChange)="setOnStockCount()"
                      mask="separator.0"
                      thousandSeparator=","
                    />
                  </div>
                  <div class="col-1 p-0 icon-size mt-4 drugpackage-status">
                    <label class="form-label label-one">
                      <i class="fa-solid fa-xmark"></i>
                    </label>
                  </div>
                  <div
                    class="col-xxl-3 p-xxl-0 col-md-5 p-md-2 col-sm-3 p-xs-0 col-5 p-2"
                  >
                    <label class="form-label" for="Number">
                      {{ "drugPackage" | translate }}
                    </label>
                    <input
                      id="DrugPackage"
                      type="text"
                      appSelectOnFocus
                      (keyup)="packageKeyUp()"
                      autocomplete="off"
                      class="form-control input-one Focusable iner-Focusable"
                      [(ngModel)]="editableItem.drugPackageCount"
                    />
                    <!-- [ngClass]="{
                        'is-invalid':
                          editableItemMessage.count != '' &&
                          editableItemMessage.count != null
                      }"
                      [options]="{ prefix: '', thousands: ',', precision: 0 }" -->
                  </div>
                  <div class="col-1 p-0 ps-2 icon-size mt-4">
                    <label class="form-label label-two col-3">
                      <i class="fa-solid fa-equals"></i>
                    </label>
                  </div>
                  <div
                    class="col-xxl-4 p-xxl-0 pe-xxl-3 col-md-12 px-md-3 col-sm-4 pe-sm-3 p-xs-0 col-12 p-2"
                  >
                    <label class="form-label" for="Number">
                      {{ "Number" | translate }}
                    </label>
                    <input
                      #count
                      id="Number"
                      type="text"
                      autocomplete="off"
                      appSelectOnFocus
                      class="form-control Focusable iner-Focusable"
                      [(ngModel)]="editableItem.count"
                      [ngClass]="{
                        'is-invalid':
                          editableItemMessage.count != '' &&
                          editableItemMessage.count != null
                      }"
                      (keyup)="countKeyUp()"
                      mask="separator.0"
                      thousandSeparator=","
                    />

                    <div class="validation-alert-count-sale-buy">
                      <p>{{ editableItemMessage.count }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="edit-form">
                  <div class="validation-alert-sale-buy">
                    <p>{{ editableItemMessage.expireDate }}</p>
                  </div>
                  <label for="expireDate" class="form-label" for="expireDate">
                    {{ "ExpireDate" | translate }}
                  </label>
                  <div class="datepicker-box">
                    <input
                      id="expireDate"
                      type="text"
                      autocomplete="off"
                      appSelectOnFocus
                      class="form-control Focusable iner-Focusable"
                      [ngClass]="{
                        'is-invalid':
                          editableItemMessage.expireDate != '' &&
                          editableItemMessage.expireDate != null
                      }"
                      [ngModel]="
                        editableItem.expireDate | dataType : 'justDate' : false
                      "
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="YYYY/MM/DD"
                    />
                    <button
                      [ngbPopover]="popoverDatapickerexpireDate"
                      [autoClose]="'outside'"
                      #datePicker="ngbPopover"
                    >
                      <i class="far fa-calendar-alt"></i>
                    </button>
                  </div>
                  <ng-template #popoverDatapickerexpireDate>
                    <app-data-picker
                      [(childProp)]="editableItem.expireDate"
                      (changeVariableMonth)="changeMonth($event)"
                    ></app-data-picker>
                  </ng-template>
                </div>
              </div>
              <div class="col-3">
                <div class="edit-form">
                  <label class="form-label" for="lot">
                    {{ "lot" | translate }}
                  </label>
                  <input
                    id="lot"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="editableItem.lot"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-3 col-md-3 mt-3">
            <div class="row input-box stock-box mx-1 p-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="input-box-title-box px-2">
                      <span>{{ "Stock" | translate : "" }}</span>
                    </div>
                    <div
                      class="record-item d-flex mt-1 p-2"
                      *ngFor="let item of editableItem.stocks; let i = index"
                    >
                      <span class="mx-1">{{ item.count }}</span>
                      <span class="mx-1">{{
                        "itemCountIn" | translate : ""
                      }}</span>
                      <span class="mx-1">{{ item.stockName }}</span>
                      <button
                        type="button"
                        class="stock-close"
                        (click)="removeStock(i)"
                      >
                        <i class="bx bx-x"></i>
                      </button>
                    </div>
                  </div>
                  <ng-container
                    *ngIf="
                      editableItem.packageCount != undefined &&
                      editableItem.packageCount > 0 &&
                      newItem.count != 0
                    "
                  >
                    <div class="col-12">
                      <div class="edit-form">
                        <div class="validation-alert-sale-buy">
                          <p>{{ editableItemMessage.stockId }}</p>
                        </div>
                        <label class="form-label label-size" for="count">
                          {{ "count" | translate }}
                        </label>
                        <input
                          class="form-control Focusable iner-Focusable"
                          [ngClass]="{
                            'is-invalid':
                              editableItemMessage.stockId != '' &&
                              editableItemMessage.stockId != null
                          }"
                          type="text"
                          autocomplete="off"
                          appSelectOnFocus
                          id="stockCount"
                          [attr.disabled]=""
                          [(ngModel)]="newItem.count"
                          mask="separator.0"
                          thousandSeparator=","
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="edit-form">
                        <div class="validation-alert-sale-buy">
                          <p>{{ editableItemMessage.stockId }}</p>
                        </div>
                        <label class="form-label label-size" for="stockName">
                          {{ "stockName" | translate }}
                        </label>
                        <select
                          id="stockName"
                          class="form-select input-select-text py-2 Focusable iner-Focusable"
                          [(ngModel)]="newItem.stockId"
                          [ngClass]="{
                            'is-invalid':
                              editableItemMessage.stockId != '' &&
                              editableItemMessage.stockId != null
                          }"
                          (change)="nextFocus()"
                        >
                          <option Value="">
                            {{ "SelectOne" | translate }}
                          </option>
                          <option
                            *ngFor="let stock of stockList"
                            [ngValue]="stock.id"
                          >
                            {{ stock.persianName }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 d-flex justify-content-center mt-2">
                      <button
                        class="btn btn-primary Focusable iner-Focusable mt-3"
                        (click)="addStock()"
                      >
                        <i class="fas fa-plus"></i>
                        {{ "ADD" | translate }}
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mt-4">
            <hr />
          </div>

          <div class="col-12 mb-3 d-flex justify-content-between">
            <button
              type="button"
              id="save-button"
              class="btn btn-primary Focusable iner-Focusable"
              (click)="saveAdd()"
            >
              <i class="far fa-save"></i>
              {{ "Save" | translate }}
            </button>
            <button
              type="button"
              id="clear-button"
              class="btn btn-light ms-2 Focusable iner-Focusable"
              (click)="exit()"
            >
              <i class="bx bx-x"></i>
              {{ "Close" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-loading-panel *ngIf="loading"> </app-loading-panel>
